export const translations = {
  en: {
    // Branding
    brand: "Active Risk Management GRC Network",
    brand_short: "ARM GRC Network",
    tagline: "A private network for governance, risk & compliance leaders.",
    // Auth
    login: "Sign in",
    register: "Create account",
    alias: "Consultant Alias",
    password: "Password",
    password_hint: "At least 12 characters, mixing at least 3 of: lowercase, uppercase, digits, symbols. Avoid common breached passwords.",
    aliasHint: "Your private identifier inside the portal (3–50 characters).",
    primary_industry: "Primary Industry (ISIC)",
    select_industry: "Select your primary industry",
    industry_hint: "Based on ISIC Rev. 4 international industry classification.",
    category: "Category",
    experience: "Years of Experience",
    areas_of_interest: "Areas of Interest",
    countries: "Countries Focused",
    submit_register: "Create my profile",
    submit_login: "Enter portal",
    next: "Next",
    back: "Back",
    have_account: "Already a member?",
    no_account: "Not a member yet?",
    sign_in_here: "Sign in here",
    register_here: "Register here",
    welcome_back: "Welcome back",
    welcome_back_sub: "Access your secure consultant workspace.",
    create_profile: "Build your profile",
    create_profile_sub: "Tell us where your expertise lies.",
    select_category: "Select category",
    select_experience: "Select experience",
    pick_at_least_one: "Select at least one option",
    step: "Step",
    of: "of",
    // Nav
    nav_chat: "Chat",
    nav_mail: "Mail",
    nav_directory: "Directory",
    nav_profile: "Profile",
    nav_admin: "Admin",
    logout: "Sign out",
    // Chat
    no_conversation: "Select a conversation",
    no_conversation_sub: "Pick a consultant from the directory to start chatting.",
    type_message: "Type a message…",
    send: "Send",
    online: "Online",
    offline: "Offline",
    conversations: "Conversations",
    search_consultants: "Search consultants",
    // Mail
    inbox: "Inbox",
    sent: "Sent",
    compose: "Compose",
    to: "To",
    subject: "Subject",
    message: "Message",
    no_emails: "No messages here yet",
    select_email: "Select an email to read",
    send_email: "Send email",
    // Directory
    directory_title: "Consultant Directory",
    directory_sub: "Browse verified GRC leaders across the region.",
    filter_by: "Filter by",
    all: "All",
    verified: "Verified",
    unverified: "Pending",
    years_exp: "years exp",
    open_chat: "Open chat",
    send_mail: "Send mail",
    // Profile
    profile_title: "Your profile",
    member_since: "Member since",
    // Admin
    admin_title: "Verification queue",
    admin_sub: "Approve or revoke verified status for consultants.",
    approve: "Approve",
    revoke: "Revoke",
    no_pending: "No pending verifications",
    ai_assistant: "AI Assistant",
    bio: "Brief about you",
    bio_hint: "3 lines about your background, focus, and what you bring to the network.",
    share_knowledge: "I'm interested in sharing my knowledge and being part of the wider ARM GRC Network",
    share_knowledge_yes: "Knowledge Sharer",
    admin_tab_sharers: "Knowledge Sharers",
    admin_no_sharers: "No members have opted in yet.",
    admin_add_comment: "Add a comment",
    admin_comment_placeholder: "Comment on this member (visible to admins only)…",
    admin_comment_save: "Save comment",
    admin_no_comments: "No comments yet.",
    posted_by: "by",
    profile_bio: "About",
    profile_no_bio: "No bio provided.",
    // MFA
    admin_mfa_kicker: "Admin two-factor",
    mfa_enroll_title: "Set up authenticator",
    mfa_verify_title: "Enter your code",
    mfa_enroll_instructions: "Scan the QR with any authenticator app (Google Authenticator, 1Password, Authy) or paste the secret manually. Then enter the 6-digit code below.",
    mfa_manual_secret: "Secret (manual)",
    mfa_code_label: "6-digit code",
    mfa_enroll_submit: "Enable two-factor",
    mfa_verify_submit: "Verify & sign in",
    mfa_use_recovery: "Lost your device? Use a recovery code",
    mfa_recovery_code_label: "Recovery code",
    mfa_recovery_submit: "Use recovery code",
    mfa_back_to_totp: "Back to authenticator code",
    mfa_verified: "Two-factor verified",
    mfa_recovered: "Signed in with recovery code",
    mfa_recovery_title_kicker: "Save these codes now",
    mfa_recovery_title: "Recovery codes",
    mfa_recovery_instructions: "Store these one-time codes somewhere safe (password manager). Each works exactly once if you lose access to your authenticator. They will NOT be shown again.",
    copy_all: "Copy all",
    copy_secret: "Copy secret",
    copied: "Copied",
    continue: "Continue to portal",
    recovery_copied: "Recovery codes copied to clipboard",
    // Featured Sharers (public)
    featured_kicker: "Featured knowledge",
    featured_title: "Meet our knowledge sharers",
    featured_sub: "Verified GRC leaders sharing insights openly across the network.",
    featured_join: "Join the network",
    featured_signin: "Sign in",
    featured_endorsements: "Endorsements",
    featured_none_yet: "No featured sharers yet. Check back soon.",
    featured_load_failed: "We couldn't load featured sharers. Please refresh in a moment.",
    featured_view_full: "See full profile — sign in",
    featured_areas: "Focus areas",
    featured_countries: "Country focus",
    featured_endorsed_by: "endorsed by",
    // Misc
    loading: "Loading…",
    error: "Something went wrong",
    success_registered: "Profile created. Pending verification.",
    success_login: "Welcome back.",
    success_message_sent: "Message sent",
    success_email_sent: "Email sent",
    success_verified: "Consultant updated",
    language: "Language",
    english: "English",
    arabic: "العربية",
  },
  ar: {
    brand: "شبكة إدارة المخاطر النشطة للحوكمة",
    brand_short: "شبكة ARM GRC",
    tagline: "شبكة خاصة لقادة الحوكمة وإدارة المخاطر والامتثال.",
    login: "تسجيل الدخول",
    register: "إنشاء حساب",
    alias: "اسم المستشار",
    password: "كلمة المرور",
    password_hint: "‏12 حرفاً على الأقل، مع مزج ٣ على الأقل من: حروف صغيرة، حروف كبيرة، أرقام، رموز. تجنّب كلمات المرور المُسرَّبة.",
    aliasHint: "معرّفك الخاص داخل البوابة (3 إلى 50 حرفاً).",
    primary_industry: "القطاع الرئيسي (ISIC)",
    select_industry: "اختر قطاعك الرئيسي",
    industry_hint: "وفقاً للتصنيف الصناعي الدولي ISIC Rev. 4.",
    category: "الفئة",
    experience: "سنوات الخبرة",
    areas_of_interest: "مجالات الاهتمام",
    countries: "الدول المستهدفة",
    submit_register: "إنشاء ملفي الشخصي",
    submit_login: "الدخول إلى البوابة",
    next: "التالي",
    back: "السابق",
    have_account: "هل أنت عضو بالفعل؟",
    no_account: "لست عضواً بعد؟",
    sign_in_here: "سجّل الدخول من هنا",
    register_here: "سجّل من هنا",
    welcome_back: "أهلاً بعودتك",
    welcome_back_sub: "ادخل إلى مساحة عمل المستشارين الآمنة.",
    create_profile: "أنشئ ملفك",
    create_profile_sub: "أخبرنا أين تكمن خبرتك.",
    select_category: "اختر الفئة",
    select_experience: "اختر سنوات الخبرة",
    pick_at_least_one: "اختر خياراً واحداً على الأقل",
    step: "خطوة",
    of: "من",
    nav_chat: "محادثة",
    nav_mail: "البريد",
    nav_directory: "الدليل",
    nav_profile: "الملف",
    nav_admin: "الإدارة",
    logout: "تسجيل الخروج",
    no_conversation: "اختر محادثة",
    no_conversation_sub: "اختر مستشاراً من الدليل لبدء المحادثة.",
    type_message: "اكتب رسالة…",
    send: "إرسال",
    online: "متصل",
    offline: "غير متصل",
    conversations: "المحادثات",
    search_consultants: "ابحث عن مستشار",
    inbox: "الوارد",
    sent: "المرسل",
    compose: "إنشاء",
    to: "إلى",
    subject: "الموضوع",
    message: "الرسالة",
    no_emails: "لا توجد رسائل بعد",
    select_email: "اختر رسالة للقراءة",
    send_email: "إرسال البريد",
    directory_title: "دليل المستشارين",
    directory_sub: "تصفّح قادة الحوكمة المعتمدين في المنطقة.",
    filter_by: "تصفية حسب",
    all: "الكل",
    verified: "موثّق",
    unverified: "قيد المراجعة",
    years_exp: "سنوات خبرة",
    open_chat: "فتح المحادثة",
    send_mail: "إرسال بريد",
    profile_title: "ملفك الشخصي",
    member_since: "عضو منذ",
    admin_title: "قائمة التوثيق",
    admin_sub: "اعتمد أو ألغِ توثيق المستشارين.",
    approve: "اعتماد",
    revoke: "إلغاء",
    no_pending: "لا توجد طلبات معلّقة",
    ai_assistant: "مساعد الذكاء الاصطناعي",
    bio: "نبذة عنك",
    bio_hint: "ثلاثة أسطر عن خلفيتك وتخصصك وما تقدمه للشبكة.",
    share_knowledge: "أرغب في مشاركة معرفتي والانضمام إلى شبكة ARM GRC الأوسع",
    share_knowledge_yes: "مشارك المعرفة",
    admin_tab_sharers: "مشاركو المعرفة",
    admin_no_sharers: "لا يوجد أعضاء اختاروا المشاركة بعد.",
    admin_add_comment: "إضافة تعليق",
    admin_comment_placeholder: "تعليق على هذا العضو (يظهر للإدارة فقط)…",
    admin_comment_save: "حفظ التعليق",
    admin_no_comments: "لا توجد تعليقات بعد.",
    posted_by: "بواسطة",
    profile_bio: "نبذة",
    profile_no_bio: "لا توجد نبذة.",
    loading: "جاري التحميل…",
    error: "حدث خطأ ما",
    success_registered: "تم إنشاء الملف. بانتظار التوثيق.",
    success_login: "أهلاً بعودتك.",
    success_message_sent: "تم إرسال الرسالة",
    success_email_sent: "تم إرسال البريد",
    success_verified: "تم تحديث حالة المستشار",
    // MFA
    admin_mfa_kicker: "مصادقة ثنائية للمشرف",
    mfa_enroll_title: "إعداد تطبيق المصادقة",
    mfa_verify_title: "أدخل رمز التحقق",
    mfa_enroll_instructions: "امسح رمز QR بأي تطبيق مصادقة (Google Authenticator، 1Password، Authy) أو الصق السر يدوياً. ثم أدخل الرمز المكوّن من 6 أرقام.",
    mfa_manual_secret: "السر (إدخال يدوي)",
    mfa_code_label: "رمز مكوّن من 6 أرقام",
    mfa_enroll_submit: "تفعيل المصادقة الثنائية",
    mfa_verify_submit: "تحقق وسجّل الدخول",
    mfa_use_recovery: "فقدت جهازك؟ استخدم رمز الاسترداد",
    mfa_recovery_code_label: "رمز الاسترداد",
    mfa_recovery_submit: "استخدم رمز الاسترداد",
    mfa_back_to_totp: "العودة إلى رمز التطبيق",
    mfa_verified: "تم التحقق بالمصادقة الثنائية",
    mfa_recovered: "تم الدخول باستخدام رمز الاسترداد",
    mfa_recovery_title_kicker: "احفظ هذه الرموز الآن",
    mfa_recovery_title: "رموز الاسترداد",
    mfa_recovery_instructions: "احتفظ بهذه الرموز في مكان آمن (مدير كلمات المرور). يمكن استخدام كل رمز مرة واحدة فقط إذا فقدت جهاز المصادقة. لن يتم عرضها مرة أخرى.",
    copy_all: "انسخ الكل",
    copy_secret: "انسخ السر",
    copied: "تم النسخ",
    continue: "المتابعة إلى البوابة",
    recovery_copied: "تم نسخ رموز الاسترداد",
    // Featured Sharers
    featured_kicker: "مشاركو المعرفة",
    featured_title: "تعرّف على مشاركي المعرفة",
    featured_sub: "قادة حوكمة معتمدون يشاركون خبراتهم علنياً عبر الشبكة.",
    featured_join: "انضم إلى الشبكة",
    featured_signin: "تسجيل الدخول",
    featured_endorsements: "التزكيات",
    featured_none_yet: "لا يوجد مشاركون مميزون بعد. تحقق قريباً.",
    featured_load_failed: "تعذّر تحميل قائمة المشاركين. حاول التحديث بعد لحظات.",
    featured_view_full: "عرض الملف الكامل — سجّل الدخول",
    featured_areas: "مجالات التركيز",
    featured_countries: "الدول المستهدفة",
    featured_endorsed_by: "زكّاه",
    language: "اللغة",
    english: "English",
    arabic: "العربية",
  },
};
